// extracted by mini-css-extract-plugin
export default {"subTitle":"ZeuY29gWVHdJh9RCdv7Q","link":"LBBtcAtWkmAGXmY_uPoq"};